import { render, staticRenderFns } from "./vw_student_count_by_branch.vue?vue&type=template&id=177d46fc&scoped=true&"
import script from "./vw_student_count_by_branch.vue?vue&type=script&lang=js&"
export * from "./vw_student_count_by_branch.vue?vue&type=script&lang=js&"
import style0 from "./vw_student_count_by_branch.vue?vue&type=style&index=0&id=177d46fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d46fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardText,VContainer,VDataTable,VProgressLinear})
